import * as React from 'react'
import Card from '@mui/material/Card'
import CardActionArea from '@mui/material/CardActionArea'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import CardContent from '@mui/material/CardContent'
import CardMedia from '@mui/material/CardMedia'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import useMediaQuery from '@mui/material/useMediaQuery'

import { useTheme } from '@mui/material/styles'

const getImagePath = name => `/images/sub-imports/${name}.png`

import { SubImportContext } from './SubImportContext'

export default function SubImportMenuItem({
    name,
    description,
    img,
    type,
    content,
    selected,
    url,
}) {
    const {
        activeSubImportDialog,
        setActiveSubImportDialog,
    } = React.useContext(SubImportContext)

    const theme = useTheme()
    const isMobile = useMediaQuery('(max-width:600px)')

    const selectedBorderColor =
        theme.palette.mode === 'dark'
            ? '2px solid #9dc8f6'
            : '2px solid #3a74cd'

    return (
        <Card
            sx={{
                width: isMobile ? 95 : 120,
                height: isMobile ? 120 : 160,
                p: 0,
                borderRadius: '16px',
                backgroundColor: theme => theme.palette.background.selectors,
            }}
        >
            <CardActionArea
                onClick={() => {
                    if (type == 'evernote') window.location.href = url
                    setActiveSubImportDialog({ type: type, content: content })
                }}
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'flex-start',
                    height: '100%',
                    pr: 0.5,
                    mr: 0.5,
                    border: selected ? selectedBorderColor : 'none',
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        position: 'relative',
                        '& .card-description, & .card-title, & .card-image': {
                            transition:
                                'opacity 0.5s ease-in-out, visibility 0.5s ease-in-out',
                        },
                        '&:hover .card-description': {
                            opacity: 1,
                            visibility: 'visible', // Ensures it's visible without affecting layout
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            padding: 2,
                        },
                        '.card-description': {
                            opacity: 0,
                            visibility: 'hidden', // Keeps space intact until hover
                        },

                        '&:hover .card-title, &:hover .card-image': {
                            opacity: 0,
                            visibility: 'hidden', // Hides without removing layout space
                        },
                        '.card-title, .card-image': {
                            opacity: 1,
                            visibility: 'visible',
                        },
                    }}
                >
                    {img && (
                        <CardMedia
                            src={img}
                            component="img"
                            image={getImagePath(img)}
                            alt="img"
                            className="card-image"
                            sx={{
                                width: isMobile ? 20 : 40,
                                height: isMobile ? 20 : 40,
                                marginLeft: 2,
                                marginTop: 2,
                            }}
                        />
                    )}
                    <CardContent
                        sx={{
                            flex: '1 0 auto',
                            pl: 1,
                            ml: 1,
                            pr: 0,
                            mr: 1,
                        }}
                    >
                        <Typography
                            className="card-title"
                            variant={isMobile ? 'body3' : 'body2'}
                            sx={{
                                pr: 0,
                                mr: 0,
                            }}
                        >
                            {name}
                        </Typography>

                        <Typography
                            variant="body3"
                            sx={{
                                color: 'text.secondary',
                            }}
                            className="card-description"
                        >
                            {isMobile || !description ? '' : description}
                        </Typography>
                    </CardContent>
                </Box>
            </CardActionArea>
        </Card>
    )
}

export function renderImportOptionsMenu(receivedMenuItems, selected) {
    const theme = useTheme()

    return (
        <Container
            sx={{
                py: 1,
                [theme.breakpoints.up('sm')]: {
                    pl: 0,
                },
                pl: 0,
                ml: 0,
            }}
        >
            <Grid
                container
                rowSpacing={2}
                justifyContent="flex-start"
                columnSpacing={2}
                alignItems="flex-start"
                pl={0}
                sx={{
                    pl: 0,
                }}
            >
                {receivedMenuItems.map(card => {
                    card.selected = card.type === selected ? true : false

                    return (
                        <Grid
                            item
                            key={card.name}
                            alignItems="flex-start"
                            sx={{
                                pl: 0,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'left',
                                '& .description-caption': {
                                    opacity: 0,
                                    transition: 'opacity 0.2s ease-in-out',
                                },
                                '&:hover .description-caption': {
                                    opacity: 1,
                                },
                            }}
                            pl={0}
                        >
                            <SubImportMenuItem {...card} />
                        </Grid>
                    )
                })}
            </Grid>
        </Container>
    )
}
